export const GET_BOOKMARKS = "GET_BOOKMARKS";
export const UPDATE_BOOKMARKED = "UPDATE_BOOKMARKED";
export const HANDLE_SEARCH_QUERY = "HANDLE_SEARCH_QUERY";
